// extracted by mini-css-extract-plugin
export var box = "testimonials-module--box--2902c";
export var testimonials = "testimonials-module--testimonials--d5646";